<div id="ReferralInfoMainContainer" class="main-container" data-cy="referrer-portal-detail-container">
  @if (currentReferral) {
    <div style="display: flex; flex-direction: column; width: 100%; height: 100%; max-height: 100%; overflow-y: hidden;" data-cy="referrer-portal-detail-content">
      <div style="display: flex;flex-direction: column; height: 100%" data-cy="referrer-portal-detail-wrapper">
        <mat-grid-list style="height:100%; width: 100%; display: flex; flex-direction: row;" data-cy="referrer-portal-detail-grid">
          <mat-grid-tile
            style="display: flex; flex-direction: column;width: 100%;" data-cy="referrer-portal-detail-tile">
            <mat-card class="referral-details-card-1" data-cy="referrer-portal-info-card">
              <mat-card-title class="section-title" data-cy="referrer-portal-info-title">Referral Information</mat-card-title>
              <table class="referral-info" data-cy="referrer-portal-info-table">
                <tr data-cy="referrer-portal-patient-row">
                  <td class="input-title-medium" data-cy="referrer-portal-patient-label">Patient:</td>
                  <td data-cy="referrer-portal-patient-value">{{currentReferral.Patient_FirstName}} {{currentReferral.Patient_MidName}}
                  {{currentReferral.Patient_LastName}}</td>
                </tr>
                <tr data-cy="referrer-portal-teeth-row">
                  <td class="input-title-medium" data-cy="referrer-portal-teeth-label">Teeth/Tooth:</td>
                  <td data-cy="referrer-portal-teeth-value">{{currentReferral.TeethDescription}}</td>
                </tr>
                <tr data-cy="referrer-portal-discomfort-row">
                  <td class="input-title-medium" data-cy="referrer-portal-discomfort-label">Discomfort Level:</td>
                  <td data-cy="referrer-portal-discomfort-value">{{currentReferral.DiscomfortLevelDescription}}</td>
                </tr>
                <tr data-cy="referrer-portal-treatment-row">
                  <td class="input-title-medium" data-cy="referrer-portal-treatment-label">For Treatment:</td>
                  <td data-cy="referrer-portal-treatment-value">{{currentReferral.TreatmentDescription}}</td>
                </tr>
              </table>
            </mat-card>
            <mat-card class="referral-details-card-2" data-cy="referrer-portal-details-card">
              <mat-tab-group animationDuration="0ms" mat-stretch-tabs style="height: 300px;overflow-y: auto;" data-cy="referrer-portal-details-tabs">
                <mat-tab label="Prescriptions" data-cy="referrer-portal-prescriptions-tab">
                  @if (isLoadingPrescriptions) {
                    <div class="spinner-container-small" data-cy="referrer-portal-prescriptions-loading">
                      <mat-spinner data-cy="referrer-portal-prescriptions-spinner"></mat-spinner>
                    </div>
                  }
                  <div style="flex: 1; overflow-y: scroll; margin-top: 2px;" data-cy="referrer-portal-prescriptions-container">
                    @if (referralPrescriptions && !isLoadingPrescriptions) {
                      <tdo-table [dataSource]="referralPrescriptions" [isMultiSelection]="false" [isSearchable]="false"
                        [isUsePaginator]="false" (rowSelected)="onPrescriptionSelected($event)" class="referrer-portal-prescriptions-table"
                        isAutoSelectFirstItem="true" noDataMessage="Prescriptions not found." data-cy="referrer-portal-prescriptions-table">
                        <tdo-table-column displayName="Date" propertyName="RxDate" isSortable="true" dataType="datetime"
                          [rowTemplate]="RxDate" data-cy="referrer-portal-prescriptions-column-date">
                          <ng-template #RxDate let-row>
                            <div data-cy="referrer-portal-prescription-date">{{row.model.RxDate | date }}</div>
                          </ng-template>
                        </tdo-table-column>
                        <tdo-table-column displayName="Medication" propertyName="MedicationName" isSortable="true" [rowTemplate]="RxMedication" data-cy="referrer-portal-prescriptions-column-medication">
                          <ng-template #RxMedication let-row>
                            @if (row.model.MedicationName) {
                              <div data-cy="referrer-portal-prescription-medication">{{ row.model.MedicationName}}</div>
                            }
                          </ng-template>
                        </tdo-table-column>
                        <tdo-table-column displayName="Code" propertyName="Code" isSortable="true"
                          [rowTemplate]="RXCode" data-cy="referrer-portal-prescriptions-column-code">
                          <ng-template #RXCode let-row>
                            <div data-cy="referrer-portal-prescription-code">{{ row.model.Code ?? 'N/A' }}</div>
                          </ng-template>
                        </tdo-table-column>
                        <tdo-table-column displayName="Dosage" propertyName="Dosage" isSortable="true"
                          [rowTemplate]="RXDosage" data-cy="referrer-portal-prescriptions-column-dosage">
                          <ng-template #RXDosage let-row>
                            @if (row.model.Dosage) {
                              <div data-cy="referrer-portal-prescription-dosage">{{ row.model.Dosage }} {{ row.model.DispenseUnit }}</div>
                            }
                          </ng-template>
                        </tdo-table-column>
                      </tdo-table>
                    }
                  </div>
                </mat-tab>
                <mat-tab label="Notes" data-cy="referrer-portal-notes-tab">
                  @if (isLoadingNotes) {
                    <div class="spinner-container-small" data-cy="referrer-portal-notes-loading">
                      <mat-spinner data-cy="referrer-portal-notes-spinner"></mat-spinner>
                    </div>
                  }
                  <div style="flex: 1; overflow-y: auto; margin-top: 2px;" data-cy="referrer-portal-notes-container">
                    @if (referralNotes && !isLoadingNotes) {
                      <tdo-table [dataSource]="referralNotes" [isMultiSelection]="false" [isSearchable]="false"
                        [isUsePaginator]="false" (rowSelected)="onNoteSelected($event)" class="referrer-portal-notes-table"
                        isAutoSelectFirstItem="true" noDataMessage="Notes not found." data-cy="referrer-portal-notes-table">
                        <tdo-table-column displayName="Date" propertyName="CreatedDate" isSortable="true"  dataType="datetime"
                          [rowTemplate]="noteDate" data-cy="referrer-portal-notes-column-date">
                          <ng-template #noteDate let-row>
                            <div data-cy="referrer-portal-note-date">{{row.model.CreatedDate | date:'short'}}</div>
                          </ng-template>
                        </tdo-table-column>
                        <tdo-table-column displayName="Note" propertyName="Note" isSortable="true" [rowTemplate]="noteText" data-cy="referrer-portal-notes-column-text">
                          <ng-template #noteText let-row>
                            @if (row.model.Note) {
                              <div data-cy="referrer-portal-note-text">{{ row.model.Note}}</div>
                            }
                          </ng-template>
                        </tdo-table-column>
                      </tdo-table>
                    }
                  </div>
                </mat-tab>
                <mat-tab label="Recall Notes" data-cy="referrer-portal-recall-notes-tab">
                  @if (isLoadingRecallNotes) {
                    <div class="spinner-container-small" data-cy="referrer-portal-recall-notes-loading">
                      <mat-spinner data-cy="referrer-portal-recall-notes-spinner"></mat-spinner>
                    </div>
                  }
                  <div style="flex: 1; overflow-y: auto; margin-top: 2px;" data-cy="referrer-portal-recall-notes-container">
                    @if (referralRecallNotes && !isLoadingRecallNotes) {
                      <tdo-table [dataSource]="referralRecallNotes" [isMultiSelection]="false" [isSearchable]="false"
                        [isUsePaginator]="false" (rowSelected)="onReferralRecallNoteSelected($event)" class="referrer-portal-recallnotes-table"
                        isAutoSelectFirstItem="true" noDataMessage="Notes not found." data-cy="referrer-portal-recall-notes-table">
                        <tdo-table-column displayName="Date" propertyName="CreatedDate" isSortable="true" dataType="datetime"
                          [rowTemplate]="recallNoteDate" data-cy="referrer-portal-recall-notes-column-date">
                          <ng-template #recallNoteDate let-row>
                            <div data-cy="referrer-portal-recall-note-date">{{row.model.CreatedDate | date:'short'}}</div>
                          </ng-template>
                        </tdo-table-column>
                        <tdo-table-column displayName="Note" propertyName="Note" isSortable="true" [rowTemplate]="noteText2" data-cy="referrer-portal-recall-notes-column-text">
                          <ng-template #noteText2 let-row>
                            <div data-cy="referrer-portal-recall-note-text">{{ row.model.Note}}</div>
                          </ng-template>
                        </tdo-table-column>
                      </tdo-table>
                    }
                  </div>
                </mat-tab>
              </mat-tab-group>
            </mat-card>
            <mat-card class="referral-details-card-3" data-cy="referrer-portal-reports-card">
              <mat-tab-group animationDuration="0ms" mat-stretch-tabs style="min-height: 300px;overflow-y: auto;" data-cy="referrer-portal-reports-tabs">
                <mat-tab label="Available Report(s)" data-cy="referrer-portal-reports-tab">
                  @if (isLoadingReports) {
                    <div class="spinner-container-small" data-cy="referrer-portal-reports-loading">
                      <mat-spinner data-cy="referrer-portal-reports-spinner"></mat-spinner>
                    </div>
                  }
                  <div style="flex: 1; overflow-y: scroll; margin-top: 2px;" class="referral-details-report" data-cy="referrer-portal-reports-container">
                    @if (referralReports && !isLoadingReports) {
                      <tdo-table [dataSource]="referralReports" [isMultiSelection]="false" [isSearchable]="false"
                        [isUsePaginator]="false" (rowSelected)="onReportSelected($event)" class="referrer-portal-reports-table"
                        isAutoSelectFirstItem="true" noDataMessage="Reports not found." data-cy="referrer-portal-reports-table">
                        <tdo-table-column displayName="Date" propertyName="xauditCreatedOn" isSortable="true" dataType="datetime"
                          [rowTemplate]="reportDate" data-cy="referrer-portal-reports-column-date">
                          <ng-template #reportDate let-row>
                            <div data-cy="referrer-portal-report-date">{{row.model.xauditCreatedOn | date: 'short'}}</div>
                          </ng-template>
                        </tdo-table-column>
                        <tdo-table-column displayName="Report Name" propertyName="ReportName" isSortable="true" [rowTemplate]="reportName" data-cy="referrer-portal-reports-column-name">
                          <ng-template #reportName let-row>
                            <div data-cy="referrer-portal-report-name">{{row.model.ReportName}}</div>
                          </ng-template>
                        </tdo-table-column>
                        <tdo-table-column displayName="Status" propertyName="SentDate" isSortable="true" [rowTemplate]="reportStatus" data-cy="referrer-portal-reports-column-status">
                          <ng-template #reportStatus let-row>
                            <div style="width: 100px;text-align: center;" data-cy="referrer-portal-report-status" [ngClass]="{'report-status-available' : row.model.SentDate !=null, 'report-status-pending': row.model.SentDate == null}">{{row.model.SentDate? 'Available' : 'Pending'}}</div>
                          </ng-template>
                        </tdo-table-column>
                        <tdo-table-column displayName="File" propertyName="File" isSortable="false" [rowTemplate]="reportFile" data-cy="referrer-portal-reports-column-file">
                          <ng-template #reportFile let-row>
                            @if (row.model.DocumentID !== null && row.model.SentDate !=null) {
                              <div (click)="openReport(row, $event)" data-cy="referrer-portal-report-file"><lucide-icon name="file" [size]="20"></lucide-icon></div>
                            }
                          </ng-template>
                        </tdo-table-column>
                      </tdo-table>
                    }
                  </div>
                </mat-tab>
                <mat-tab label="Images" data-cy="referrer-portal-images-tab">
                  @if (isLoadingImages) {
                    <div class="spinner-container-small" data-cy="referrer-portal-images-loading">
                      <mat-spinner data-cy="referrer-portal-images-spinner"></mat-spinner>
                    </div>
                  }
                  @if (!isLoadingImages) {
                    <div class="image-grid" data-cy="referrer-portal-image-grid" style="flex: 1; overflow-y: scroll; margin-top: 2px;">
                      @if (imageThumbnails.length ==0) {
                        <span style="margin-top: 20px;" data-cy="referrer-portal-images-empty">Images for referral not found.</span>
                      }
                      @for (image of imageThumbnails; track image) {
                        <div style="align-self: center;" (dblclick)="openImage(image)" data-cy="referrer-portal-image-container">
                          <mat-card class="image-card" data-cy="referrer-portal-image-card">
                            <img mat-card-image [src]="image.src | secureImage | async" data-cy="referrer-portal-image"/>
                            <mat-card-footer data-cy="referrer-portal-image-footer">
                              <div data-cy="referrer-portal-image-date">{{image.DocumentCreateDate | date:'short'}}</div>
                              @for (tag of image.dataDocumentTags; track tag) {
                                <span data-cy="referrer-portal-image-tag"> {{getTagValue(tag.enumDocumentTagID)}} </span>
                              }
                            </mat-card-footer>
                          </mat-card>
                        </div>
                      }
                    </div>
                  }
                </mat-tab>
              </mat-tab-group>
            </mat-card>
          </mat-grid-tile>
        </mat-grid-list>
      </div>
    </div>
  }
</div>
